import React, { Component } from "react";
import { connect } from "react-redux";
import IntlMessages from "../../utils/IntlMessages";
import {
  collapsedAllMenu,
  signupOpenNoti,
  signinOpenNotFound,
  validateToken,
  authClosePopup,
} from "../../actions";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  FormGroup,
  Col,
} from "reactstrap";
import LogoWrs from "../../assets/images/WRSLOGO.png";
import renderFieldInputText from "../../utils/CustomField/renderFieldInputText";
import authenBanner from "../../assets/images/LoginBanner6000X2400.png"
import authenBanner2 from "../../assets/images/LoginBanner1920X500.png"
import { Link } from "react-router-dom";
import { authSignIn } from "../../actions";
import { reduxForm, Field } from "redux-form";

class signIn extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 1,
      username: "",
      password: "",
      signInDisplayPassword: false,
      signUpDisplayPassword: false,
      signUpDisplayPasswordConfirm: false,
      signup_name: "",
      signup_mobile: "",
      signup_email: "",
      signup_password: "",
      signup_password_confirm: "",
      isChecked: true,
      modal: false,
      action: "create",
    };
  }

  // callModal(){
  //   this.setState({modal : !this.state.modal?!this.state.modal:false});
  // }

  toggleSignInDisplayPassword() {
    this.setState({
      signInDisplayPassword: !this.state.signInDisplayPassword,
    });
  }
  
  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  handleChecked = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };

  login = () => {
    if (this.state.username !== "" && this.password !== "") {
      this.props.authSignIn({
        username: this.state.username,
        password: this.state.password,
        page_lang: this.props.locale.locale,
      });
    }
  };

  render() {
    const { closeModal, formValues, auth } = this.props;

    let iconEye, inputType;
    if (this.state.signInDisplayPassword) {
      inputType = "text";
      iconEye = "icon icon-ico-eye-1";
    } else {
      inputType = "password";
      iconEye = "icon icon-ico-eye-2";
    }

    if (auth && auth.success) {
      document.location = "/#/";
    }

    return (
      <>
        <div className="authen-banner text-center">
         
         <img src={authenBanner}  alt="Eastspring Wealth Privilege" className="d-md-none"/>
         <img src={authenBanner2} alt="Eastspring Wealth Privilege" className="d-none d-md-inline w-100"/>
          <div className="authen-category">
            <div className="justify-content-center text-center">
              <div className="row text-center col-12 col-md-6 col-lg-4 col-xl-3 m-0 p-0 mx-auto">
                {/*<div
                  className={`authen-category-item col pt-2 pb-3 ${
                    this.state.activeTab === 1 && "active"
                  }`}
                  onClick={() => this.toggle(1)}
                >
                   <IntlMessages id="authen.sign-in"></IntlMessages>
                </div>*/}

                {/* <div
                  className={`authen-category-item col pt-2 pb-3 ${
                    this.state.activeTab === 2 && "active"
                  }`}
                  onClick={() =>{
                      this.toggle(2);
                      this.setState({action:"Register"});
                    }
                  }
                >
                  <IntlMessages id="authen.sign-up"></IntlMessages>
                </div> */}
              </div>
            </div>
          </div>
          {/* <div className="div-gradient-authen"></div> */}
        </div>

        {this.state.activeTab === 1 ? (
          <>
            <div className="sign-in-page container text-left ">
           
              <div className="col-md-6 col-lg-6 col-xl-4 mx-auto">
                <h2>
                  <IntlMessages id="authen.sign-in.title" />
                </h2>
                <form className="form-login" autoComplete="off">
                  <div className="sign-in-form">
                    <div className="form-group">
                      <div className="position-relative">
                        <label htmlFor="username">
                          <IntlMessages id="authen.sign-in.privilegeCode"></IntlMessages>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="username"
                          name="username"
                          onChange={(e) => {
                            this.setState({
                              username: e.currentTarget.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="form-group">
                      <div className="position-relative">
                        <div
                       
                          className="switch-eye"
                          tabIndex="-1"
                          onClick={() => {
                            this.toggleSignInDisplayPassword();
                          }}
                        >
                          <i className={iconEye}></i>
                        </div>
                        <label htmlFor="password">
                          <IntlMessages id="authen.sign-in.password"></IntlMessages>
                        </label>

                        <input
                          type={inputType}
                          className="form-control"
                          id="password"
                          name="password"
                          onChange={(e) => {
                            this.setState({
                              password: e.currentTarget.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    {/* <p className="error-desc mt-4">
                      <Link to="/request-reset-password">
                        <IntlMessages id="authen.sign-in.forgot" />
                      </Link>
                    </p> */}
                  </div>
                  <button
                    className="submit-button"
                    type="button"
                    onClick={() => {
                       this.login();
                    }}
                  >
                    <IntlMessages id="authen.sign-in.button" />
                  </button>

                  {closeModal ? (
                    <button
                      className="btn btn-wrs-clear my-3"
                      type="button"
                      onClick={() => {
                        closeModal();
                        this.props.authClosePopup();
                      }}
                    >
                      CANCEL
                    </button>
                  ) : (
                    ""
                  )}
                  <div className="w-100 text-center logoWRSPageLogin">
                  <img src={LogoWrs} alt="World Reward Solutions"/>
                    <p>Powered by<br/>World Reward Solutions</p>
                  </div>
                </form>
              </div>
            </div>
          </>
        ) : (
          ""
        )}
        {this.state.activeTab === 2 ? (
          <>
            <div className="sign-up-page container text-left ">
              <div className="col-md-6 col-lg-6 col-xl-4 mx-auto">
                <h2>
                  <IntlMessages id="authen.sign-up.title" />
                </h2>
                {this.state.action !== "Register" ? (
                  ""
                ) : (
                  <div className="animated fadeIn">
                    <form
                      className="form-horizontal"
                      onSubmit={() => {
                        // this.props.memberRegister(formValues);
                      }}
                    >
                      <input type="hidden" name="gigya_uid" />
                      <input type="hidden" name="user_signup_token" />
                      <Field
                        name="name"
                        type="text"
                        component={renderFieldInputText}
                        label="Name *"
                      />
                      <Field
                        name="mobile"
                        type="text"
                        component={renderFieldInputText}
                        label="Mobile *"
                      />
                      <Field
                        name="email"
                        type="email"
                        component={renderFieldInputText}
                        label="Email *"
                      />
                      <Field
                        name="password"
                        type="password"
                        component={renderFieldInputText}
                        label="Password *"
                      />
                      <Field
                        name="re_password"
                        type="password"
                        component={renderFieldInputText}
                        label="Confirm Password *"
                      />
                      <Button
                        type="button"
                        color="primary"
                        style={{ width: "100%" }}
                        id="btn-sign-up"
                        // onClick={() => this.callModal()}
                      >
                        {" "}
                        SIGN UP{" "}
                      </Button>
                      <Button
                        type="submit"
                        color="danger"
                        style={{ display: "none" }}
                        id="btn-send-sign-up"
                        ref={(input) => (this.inputElement = input)}
                      >
                        Register
                      </Button>
                    </form>
                    {/* <Modal
                      isOpen={this.state.modal === true}
                      toggle={this.callModal}
                    >
                      <ModalHeader
                        style={{
                          fontFamily: "Roboto",
                          fontStyle: "normal",
                          fontWeight: "500",
                          fontSize: "34px",
                          lineHeight: "24px",
                          margin: "auto",
                        }}
                      >
                        Terms & Conditions
                      </ModalHeader>
                      <ModalBody style={{ flex: 1, wordWrap: "break-word" }}>
                        <p>
                          These terms and conditions outline the rules and
                          regulations for the use of The Lifestyle's Website.
                        </p>
                        <p>
                          By accessing this website we assume you accept these
                          terms and conditions in full. Do not continue to use
                          The Lifestyle's website if you do not accept all of
                          the terms and conditions stated on this page.
                        </p>
                        <p>
                          The following terminology applies to these Terms and
                          Conditions, Privacy Statement and Disclaimer Notice
                          and any or all Agreements: "Client", "You" and "Your"
                          refers to you, the person accessing this website and
                          accepting the Company's terms and conditions. "The
                          Company", "Ourselves", "We", "Our" and "Us", refers to
                          our Company. "Party", "Parties", or "Us", refers to
                          both the Client and ourselves,
                        </p>
                      </ModalBody>
                      <ModalFooter style={{ display: "block" }}>
                        <FormGroup row>
                          <Col
                            md="12"
                            style={{ fontSize: "24px", paddingLeft: "38px" }}
                          >
                            <input
                              className="form-input-check"
                              name="accept_term"
                              type="checkbox"
                              value="accept"
                              onChange={this.handleChecked}

                            />{" "}
                            I agree to the Terms & Conditions
                          </Col>
                        </FormGroup>
                        <FormGroup row>
                          <Col md="12">
                            <Button
                              type="submit"
                              color="primary"
                              style={{ width: "100%" }}
                              id="btn-submit"
                              disabled={this.state.isChecked}
                              onClick={() => {
                              }}
                            >
                              {" "}
                              SIGN UP{" "}
                            </Button>
                          </Col>
                        </FormGroup>
                      </ModalFooter>
                    </Modal> */}
                  </div>
                )}
              </div>
            </div>
          </>
        ) : (
          ""
        )}
      </>
    );
  }
}

function validate(values) {
  const errors = {};
  var regPhoneNo = new RegExp("^0[0-9]+$");
  if (!values.mobile) {
    errors.mobile = "Required";
  } else if (!regPhoneNo.test(values.mobile)) {
    errors.mobile = "Phone number wrong Pattern";
  } else if (values.mobile.length !== 10) {
    errors.mobile = "Must be 10 characters";
  }

  if (!values.name) {
    errors.name = "Required";
  } else if (values.name.length > 100) {
    errors.name = "Must be 100 characters or less";
  }
  if (!values.email) {
    errors.email = "Required";
  }

  if (!values.username) {
    errors.username = "Required";
  }


  if (!values.password) {
    errors.password = "Required";
  } else if (values.password.length > 100) {
    errors.password = "Must be 100 characters or less";
  } else if (values.password.length < 6) {
    errors.password = "Must be 6 characters or more";
  }

  if (!values.re_password) {
    errors.re_password = "Required";
  } else if (values.re_password !== values.password) {
    errors.re_password = "Password and Confirm Password not match";
  }
  return errors;
}

const mapStateToProps = ({ form, setting, auth }, ownProps) => {
  let formValues;
  let initialValues;
  if (!(ownProps.modalLogin && ownProps.modalLogin === true)) {
    var url = ownProps.location.search.split("&");
    formValues = form.FormRegister ? form.FormRegister.values : null;
    if (url[0] !== "") {
      const id = url.length !== 0 ? url[0].split("=")[1] : "";
      const token = url.length !== 0 ? url[1].split("=")[1] : "";
      initialValues = {
        id: id,
        token: token,
      };
    }
  }
  const { locale } = setting;
  return { formValues, locale, auth, initialValues };
};

signIn = reduxForm({ validate, form: "FormRegister" })(signIn);

export default connect(mapStateToProps, {
  authSignIn,
  collapsedAllMenu,
  signupOpenNoti,
  signinOpenNotFound,
  validateToken,
  authClosePopup,
})(signIn);
